<div class="hc-input-dropdown">
  <button type="button"
          [class]="containerClass"
          [id]="inputId"
          [disabled]="disabled"
          (click)="toggle()"
          [attr.aria-expanded]="isOpen"
          aria-haspopup="listbox">
    @if (selectedCountry) {
      <span class="hc-input-country__flag">{{ selectedCountry.flag }}</span>
      <span class="hc-input__value">{{ selectedCountry.name }}</span>
    } @else {
      <span class="hc-input__placeholder">{{ placeholder }}</span>
    }
    <lucide-icon [name]="isOpen ? 'chevron-up' : 'chevron-down'" [size]="24" class="hc-input__icon hc-input__icon--right" aria-hidden="true"></lucide-icon>
  </button>

  @if (isOpen) {
    <div class="hc-input-dropdown__menu hc-input-country__menu">
      <div class="hc-input-country__search">
        <lucide-icon name="search" [size]="18" class="hc-input__icon" aria-hidden="true"></lucide-icon>
        <input type="text"
               class="hc-input-country__search-input"
               placeholder="Search countries..."
               [value]="searchQuery"
               (input)="onSearchInput($event)" />
      </div>
      <ul class="hc-input-country__list" role="listbox">
        @for (country of filteredCountries; track country.code) {
          <!-- eslint-disable-next-line @angular-eslint/template/interactive-supports-focus -->
          <li class="hc-input-dropdown__option hc-input-country__option"
              [class.hc-input-dropdown__option--selected]="country.code === value"
              role="option"
              [attr.aria-selected]="country.code === value"
              (click)="select(country)">
            <span class="hc-input-country__flag">{{ country.flag }}</span>
            <span>{{ country.name }}</span>
          </li>
        }
      </ul>
    </div>
  }
</div>
